import { render, staticRenderFns } from "./BatchPostule.vue?vue&type=template&id=047144aa&"
import script from "./BatchPostule.vue?vue&type=script&lang=js&"
export * from "./BatchPostule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('047144aa')) {
      api.createRecord('047144aa', component.options)
    } else {
      api.reload('047144aa', component.options)
    }
    module.hot.accept("./BatchPostule.vue?vue&type=template&id=047144aa&", function () {
      api.rerender('047144aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/aduanas/batches/views/components/modals/BatchPostule.vue"
export default component.exports